import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import { GoPrimitiveDot } from 'react-icons/go';
import { Link } from "react-router-dom";

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";

//Assets
import ContractIcon from "../../../../images/contract.png";

//Interface
import { WrapperAndComponentInterface } from "./definitions";

const WrapperAndComponent: FC<WrapperAndComponentInterface> = ({
  onOK
}) => {
  return (
    <CustomBody>
      <div className="pickup-notes-body">
        <KickImage className="notes-icon" src={ContractIcon} alt="pickup-address" />
        <p className="header">Pick-up Notes</p>
        <p className="info">Few reminders for you: </p>
        <div className="contract-detail-wrapper">
          <div className="list">
            <GoPrimitiveDot size={14} />
            <div>
              <p>Make sure the package is properly ready for delivery and remember your time schedule.</p>
              <p className="guide"><Link to="/helps/general-faq" target="_blank">See packaging guide</Link></p>
            </div>
          </div>
          <div className="list">
            <GoPrimitiveDot size={14} />
            <div>
              <p>There are no pick-up on Sundays and any other national holidays. Pick-ups will be done the day after.</p>
            </div>
          </div>
          <div className="list">
            <GoPrimitiveDot size={14} />
            <div>
              <p>Make sure your address is clear for the courier to access or be aware of any incoming calls / messages from us inquiring this information</p>
            </div>
          </div>
        </div>
        <CustomButton
          text={"OK"}
          disabled={false}
          onClick={() => onOK()}
        />
      </div>
    </CustomBody>
  )
}
WrapperAndComponent.defaultProps = {
  onOK: () => { }
}

export default WrapperAndComponent;